import { BookingCompressed, ResourceStateDto, ResourceStateDtoStatusEnum } from '@jooxter/api';
import { Matrix, ResourceNode, DeviceNode } from '../../types/matrix.types';
// eslint-disable-next-line import/namespace
import { LayoutRectangle } from 'react-native';

// Re-export matrix types for backward compatibility
export type { Matrix, ResourceNode, DeviceNode };

export interface IBackgroundImage {
  width: number;
  height: number;
  uri: string;
  naturalWidth: number;
  naturalHeight: number;
}

export interface IJxtFloorPlan {
  backgroundImage?: IBackgroundImage;
  width?: number;
  height?: number;
  pictos?: IPictoConfig[];
  changePictoPriority?: (p: IPictoConfig) => void;
  onClick?: (id: number) => void;
  /** Once ready, zoomed in on this picto, brought to the middle, and bumped (locating one space). */
  focusPictoId?: number;
}

export interface IPictoConfig {
  id: number;
  priority: number;
  size: number;
  x: number;
  y: number;
  userInitials?: string;
  firstName?: string;
  lastName?: string;
  url: string;
  type: PictoTypeEnum;
  title?: string;
  subtitle?: string;
  showMapIcon: boolean;
  isFavorite?: boolean;
  occupantsCount?: number;
  capacity?: number;
  status?: ResourceStateDtoStatusEnum;
  heatmapIntensity?: number;
}

export interface IJxtPictoGroup {
  p: IPictoConfig;
  onPictoClick: (id: number) => void;
  changePictoPriority?: (p: IPictoConfig) => void;
  computedRatio?: number;
  isHovered?: boolean;
}

export type TCanvas = LayoutRectangle | SVGSVGElement;

export enum PictoTypeEnum {
  User = 'User',
  Booking = 'Booking',
  Resource = 'Resource',
  Heatmap = 'Heatmap',
}

export type Dimensions = {
  width: number;
  height: number;
};

export type ScalingObject = {
  scaleX: number;
  scaleY: number;
};

export interface Position {
  col: number;
  row: number;
}

export interface IFloorPlanResource {
  id: number;
  bookings?: BookingCompressed[];
  name: string;
  bookable?: boolean;
  capacity: number;
  resourceType: {
    mapIconSize: number;
    showMapIcon: boolean;
    allowOverlap: boolean;
  };
  state?: {
    pictogram?: string;
    occupantsCount?: number;
    status?: ResourceStateDtoStatusEnum;
  };
  favorite?: boolean;
}

export interface IFloorPlanBooking {
  id: number;
  resource: {
    id: number;
    resourceType: {
      mapIconSize: number;
    };
    state?: ResourceStateDto;
  };
  organizer: {
    firstname: string;
    lastname: string;
    picture?: string;
  };
}

export type THandle = {
  id: number;
  locate: () => void;
  fade: () => void;
};
